import type { GenericLanguages } from '@payloadcms/translations'

export const i18n: Partial<GenericLanguages> = {
  ar: {
    label: 'قائمة غير مرتبة',
  },
  az: {
    label: 'Sırasız Siyahı',
  },
  bg: {
    label: 'Неподреден списък',
  },
  cs: {
    label: 'Neuspořádaný seznam',
  },
  da: {
    label: 'Usorteret Liste',
  },
  de: {
    label: 'Ungeordnete Liste',
  },
  en: {
    label: 'Unordered List',
  },
  es: {
    label: 'Lista desordenada',
  },
  et: {
    label: 'Sorteerimata loend',
  },
  fa: {
    label: 'لیست بدون ترتیب',
  },
  fr: {
    label: 'Liste non ordonnée',
  },
  he: {
    label: 'רשימה לא מסודרת',
  },
  hr: {
    label: 'Neuređeni popis',
  },
  hu: {
    label: 'Rendezetlen lista',
  },
  is: {
    label: 'Óraðaður listi',
  },
  it: {
    label: 'Elenco non ordinato',
  },
  ja: {
    label: '順不同リスト',
  },
  ko: {
    label: '비정렬 목록',
  },
  my: {
    label: 'Senarai Tidak Tertib',
  },
  nb: {
    label: 'Usortert liste',
  },
  nl: {
    label: 'Ongeordende lijst',
  },
  pl: {
    label: 'Nieuporządkowana lista',
  },
  pt: {
    label: 'Lista Não Ordenada',
  },
  ro: {
    label: 'Listă neordonată',
  },
  rs: {
    label: 'Неуређена листа',
  },
  'rs-latin': {
    label: 'Neuređena lista',
  },
  ru: {
    label: 'Несортированный список',
  },
  sk: {
    label: 'Neusporiadaný zoznam',
  },
  sl: {
    label: 'Neurejen seznam',
  },
  sv: {
    label: 'Oordnad lista',
  },
  ta: {
    label: 'வரிசைப்படுத்தப்படாத பட்டியல்',
  },
  th: {
    label: 'รายการที่ไม่ได้เรียงลำดับ',
  },
  tr: {
    label: 'Sırasız Liste',
  },
  uk: {
    label: 'Невпорядкований список',
  },
  vi: {
    label: 'Danh sách không theo thứ tự',
  },
  zh: {
    label: '无序列表',
  },
  'zh-TW': {
    label: '無順序列表',
  },
}
